<template>
  <div class="article-image-container">
    <div class="article-image" :class="classes">
      <AddFromPhoto
        v-if="productHandle"
        :product-handle="productHandle"
        :image-url="images"
      />
      <Picture v-else :images="images" />
      <div v-if="credit" class="credit">{{ credit }}</div>
    </div>
  </div>
</template>

<script>
import Picture from "@/components/Picture.vue";
import AddFromPhoto from "@/components/AddFromPhoto.vue";
export default {
  name: "ArticleImage",
  components: {
    Picture,
    AddFromPhoto,
  },
  props: {
    images: {
      type: Object,
      required: true,
    },
    productHandle: {
      type: String,
      default: null,
    },
    block: {
      type: Boolean,
      default: false,
    },
    maxWidthPortrait: {
      type: Boolean,
      default: false,
    },
    maxWidthLandscape: {
      type: Boolean,
      default: false,
    },
    containerMobile: {
      type: Boolean,
      default: false,
    },
    block10px: {
      type: Boolean,
      default: false,
    },
    block20px: {
      type: Boolean,
      default: false,
    },
    credit: {
      type: String,
      default: null,
    },
    containerOff: {
      type: Boolean,
      default: false,
    },
    paddingOff: {
      type: Boolean,
      default: false,
    },
    imageOverlap: {
      type: Boolean,
      default: false,
    },
    block0Mobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        "article-image--block": this.block,
        "article-image--block0Mobile": this.block0Mobile,
        "article-image--block10px": this.block10px,
        "article-image--block20px": this.block20px,
        "article-image--containerMobile": this.containerMobile,
        "article-image--maxWidthPortrait": this.maxWidthPortrait,
        "article-image--maxWidthLandscape": this.maxWidthLandscape,
        "article-image--containerOff": this.containerOff,
        "article-image--paddingOff": this.paddingOff,
        "article-image--image-overlap": this.imageOverlap,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.article-image {
  line-height: 0;
  margin: 0 auto 60px;
  max-width: 1200px;
  position: relative;

  @include respond-above(md) {
    padding: 0 20px;
    max-width: 1600px;
    width: 100%;
    margin: 0 auto 80px;
  }

  &--block {
    margin: 0 auto 2px;

    @include respond-above(md) {
      margin: 0 auto;
    }
  }

  &--block0Mobile {
    margin: 0 auto 0px;

    @include respond-above(md) {
      margin: 0 auto;
    }
  }

  &--block20px {
    margin: 0 auto 20px;
  }

  &--block10px {
    margin: 0 auto 10px;
  }

  &--containerMobile {
    padding: 0 20px;
  }

  &--maxWidthPortrait {
    max-width: 275px;
    @include respond-above(md) {
      max-width: 627px;
    }
  }

  &--maxWidthLandscape {
    max-width: 1116px;
    z-index: 1;
  }

  &--containerOff {
    max-width: none;
    padding: 0;
  }
  &--paddingOff {
    padding: 0;
  }
  &--image-overlap {
    margin-top: -350px;
  }
}
.article-image-text {
  margin: 0 auto;
  max-width: 1400px;
}

.credit {
  bottom: 20px;
  color: $color-white;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.49px;
  left: 20px;
  position: absolute;
}
</style>
